<template>
  <div :style="{ '--buttonTextColor': webDesign.design.button_text_color }">
    <footer
      v-if="webDesign === null && subdomain === 'ucoin'"
      :class="['footer d-none d-md-block', subdomain]"
    >
      <div class="container">
        <b-row no-gutters cols="1" cols-md="2">
          <b-col class="left-content">
            <a
              href=" https://www.rush.ph/"
              target="_blank"
              rel="noopener"
              class="buttom-brand"
              >Powered by <b>RUSH</b></a
            >
            <a href="#" class="d-none"
              >Like us on
              <img src="../../assets/images/ic-facebook.png" alt="FB" />
            </a>
            <a href="#" class="d-none"
              >Follow us on
              <img src="../../assets/images/ic-instagram.png" alt="IG" />
            </a>
          </b-col>
          <b-col class="right-content">
            <div class="right-nav">
              <a :href="`/${subdomain}/privacy-policy`" target="_blank">
                Privacy Policy
              </a>
              <a href="#" class="d-none"
                >Follow us on
                <img src="../../assets/images/ic-instagram.png" alt="IG" />
              </a>
            </div>
          </b-col>
        </b-row>
      </div>
    </footer>
    <footer
      v-else-if="webDesign !== null && webDesign.design !== null"
      :style="{ backgroundColor: webDesign.design.main_color }"
      :class="['footer d-none d-md-block', subdomain]"
    >
      <div class="container">
        <b-row no-gutters cols="1" cols-md="2">
          <b-col class="left-content">
            <a
              href=" https://www.rush.ph/"
              target="_blank"
              rel="noopener"
              class="buttom-brand"
              >Powered by <b>RUSH</b></a
            >
            <a href="#" class="d-none"
              >Like us on
              <img src="../../assets/images/ic-facebook.png" alt="FB" />
            </a>
            <a href="#" class="d-none"
              >Follow us on
              <img src="../../assets/images/ic-instagram.png" alt="IG" />
            </a>
          </b-col>
          <b-col class="right-content">
            <div class="right-nav">
              <router-link
                :to="`/${subdomain}/privacy-policy`"
                :target="
                  $route.name === 'PrivacyPolicy' ||
                  $route.name === 'TermsOfUse'
                    ? null
                    : '_blank'
                "
                class="footer-link"
              >
                {{ subdomain === "ucoin" ? "FAQ" : "Privacy Policy" }}
              </router-link>
              <span class="separator"></span>
              <router-link
                :to="`/${subdomain}/terms-of-use`"
                :target="
                  $route.name === 'PrivacyPolicy' ||
                  $route.name === 'TermsOfUse'
                    ? null
                    : '_blank'
                "
                class="footer-link"
              >
                Terms of Use
              </router-link>
            </div>
          </b-col>
        </b-row>
      </div>
    </footer>
    <footer v-else :class="'footer d-none d-md-block' + subdomain">
      <div class="container">
        <b-row no-gutters cols="1" cols-md="2">
          <b-col class="left-content">
            <a
              href=" https://www.rush.ph/"
              target="_blank"
              rel="noopener"
              class="buttom-brand"
              >Powered by <b>RUSH</b></a
            >
            <a href="#" class="d-none"
              >Like us on
              <img src="../../assets/images/ic-facebook.png" alt="FB" />
            </a>
            <a href="#" class="d-none"
              >Follow us on
              <img src="../../assets/images/ic-instagram.png" alt="IG" />
            </a>
          </b-col>
          <b-col class="right-content">
            <div class="right-nav">
              <router-link
                :to="`/${subdomain}/privacy-policy`"
                :target="
                  $route.name === 'PrivacyPolicy' ||
                  $route.name === 'TermsOfUse'
                    ? null
                    : '_blank'
                "
              >
                {{ subdomain === "ucoin" ? "FAQ" : "Privacy Policy" }}
              </router-link>
              <span class="separator"></span>
              <router-link
                :to="`/${subdomain}/terms-of-use`"
                :target="
                  $route.name === 'PrivacyPolicy' ||
                  $route.name === 'TermsOfUse'
                    ? null
                    : '_blank'
                "
              >
                Terms of Use
              </router-link>
            </div>
          </b-col>
        </b-row>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Footer",
  computed: {
    ...mapState("merchant", {
      merchantIsLoading: state => state.loading,
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign
    })
  }
};
</script>

<style scoped lang="scss">
.footer {
  // position: absolute;
  background-color: #ff8a00;
  bottom: 0;
  width: 100%;
  padding: 10px 0px;
  color: #ffffff;

  .buttom-brand {
    font-size: 13px;
    font-weight: 300;
    b {
      font-weight: 700;
    }
    text-decoration: none;
  }

  a {
    margin: 0 20px;
    color: #ffffff;
    font-weight: 300;
    img {
      margin-top: -1px;
      margin-left: 5px;
      display: inline-block;
    }
  }
  .left-content {
    text-align: center;
  }
  .right-content {
    text-align: center;
  }
  .separator:before,
  .footer-link {
    color: var(--buttonTextColor, #2f3941);
  }
  @media (min-width: 768px) {
    .left-content {
      text-align: left;
    }
    .right-content {
      text-align: right;
    }
  }
}
</style>
